import { graphql } from "react-relay";
import { AutopilotForm } from "./AutopilotForm";

export const autopilotFormSaveOnEditFragments = {
  user: graphql`
    fragment AutopilotFormSaveOnEdit_user on User {
      emails

      webAppFlagsErrorable {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on Flags {
          flags
        }
      }
    }
  `,
  eventParent: graphql`
    fragment AutopilotFormSaveOnEdit_eventParent on EventParent {
      id
      externalEventId
    }
  `,
  event: graphql`
    fragment AutopilotFormSaveOnEdit_event on Event
    @argumentDefinitions(calendarId: { type: "String!" }) {
      ...AutopilotForm_event @arguments(calendarId: $calendarId)
      title
      isAllDay
      locked
      eventKey {
        externalEventId
      }
      autopilotEventStatus(calendarId: $calendarId) {
        __typename

        ... on AutopilotEventStatus {
          status
        }
      }
      startTime {
        dateOrDateTime
        millis
      }
      organizer {
        urnValue
      }
      attendees {
        displayName
        urnValue
      }
      annotatedEvent {
        orgTags {
          tag
          state {
            active
            value
            subjectType
            subjectValue
            lastModified
          }
        }
      }
      annotatedRecurringEvent {
        orgTags {
          tag
          state {
            active
            value
            subjectType
            subjectValue
            lastModified
          }
        }
      }
      attendeePeople {
        __typename
        ... on PersonList {
          list {
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
          }
        }
      }
      suggestedAutopilotSettingsResponseV3 {
        __typename
        ... on SuggestedAutopilotSettingsResponseV3 {
          intersectionOfAttendeesMeetingHours {
            minSlot {
              dayOffset
              timeSlot
            }
            maxSlot {
              dayOffset
              timeSlot
            }
          }
          calendarIdToMeetingHours {
            calendarId
            dayOffsetTimeSlotRanges {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
          }
          suggestedAutopilotSettings {
            isRoomFlexible
            movementType
            allowedEndTime {
              dayOffset
              timeSlot
            }
            allowedStartTime {
              dayOffset
              timeSlot
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
      moveRangeInLocalTimeV3 {
        __typename
        ... on MoveRangeInLocalTimeV3 {
          allowedStartTimeInclusive {
            dayOffset
            timeSlot
          }
          allowedEndTimeInclusive {
            dayOffset
            timeSlot
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
  org: graphql`
    fragment AutopilotFormSaveOnEdit_org on Org
    @argumentDefinitions(
      calendarIds: { type: "[String]!", defaultValue: [] }
      userIds: { type: "[String]!", defaultValue: [] }
    ) {
      ...AutopilotForm_org
      id
      experiments
      personsByUserIdsErrorable(userIds: $userIds) {
        __typename
        ... on PersonList {
          list {
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
          }
        }
        ... on GraphEntityError {
          message
        }
      }
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          list {
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};

export const refetchQuery = graphql`
  query AutopilotFormSaveOnEditQuery(
    $orgRelayId: ID!
    $userIds: [String]!
    $calendarIds: [String]!
  ) {
    org: node(id: $orgRelayId) {
      ... on Org {
        ...AutopilotFormSaveOnEdit_org @arguments(userIds: $userIds, calendarIds: $calendarIds)
      }
    }
  }
`;
